// Mock data for Shyam Tex Hub website

export const companyInfo = {
  name: "SHYAM TEX HUB",
  tagline: "A House of Export Fabrics",
  subTagline: "We Weave Trust in Every Fabric",
  phone: "+91 98256 42969",
  phoneNumbers: [
    { type: "Office", number: "0261-2270834" },
    { type: "Mobile", number: "+91 9825642969" },
    { type: "Mobile", number: "+91 9601927898" },
    { type: "Mobile", number: "+91 9484568369" }
  ],
  email: "shyamtexhub@gmail.com",
  address: "339-340, Arihant Complex, Nr. A.P. Market, Opp. Harinagar-1, Main Road, UDHNA, SURAT-394210",
  googleMapsLink: "https://maps.google.com/?q=339-340,+Arihant+Complex,+Udhna,+Surat-394210",
  owner: "Shiv Joshi"
};

export const aboutContent = {
  description: "Shyam Tex Hub is a dynamic and forward-thinking manufacturer and supplier of premium polyester fabrics, proudly based in Surat, India. With decades of collective experience in the textile industry, we have cultivated a reputation for excellence, driven by our commitment to quality, innovation, and unwavering client satisfaction. Our state-of-the-art production facilities are equipped to handle large-scale manufacturing while maintaining meticulous attention to detail at every stage of the process.",
  vision: "To become a trustworthy global leader in the textile industry, recognized for our innovative spirit and the superior quality of our polyester fabrics. We aim to set new benchmarks by pioneering sustainable and ethical manufacturing processes, inspiring confidence and trust in our global partners.",
  mission: "Our mission is to empower our clients with the finest fabrics and customized solutions that fuel their success. We are dedicated to building enduring, collaborative partnerships by consistently exceeding expectations on quality, delivery, and value.",
  manufacturing: {
    title: "Manufacturing Excellence",
    description: "Our state-of-the-art production facilities are equipped to handle high-volume production with consistent quality. We manage the entire value chain in-house, from raw material to the final product, giving clients complete flexibility for their fabric design.",
    capabilities: [
      "High-volume production with consistent quality control",
      "Complete in-house value chain management",
      "Solid dyeing services",
      "Printing and digital printing (including ink print)",
      "Custom fabric development"
    ]
  },
  globalReach: "Our comprehensive logistics network ensures seamless delivery, whether domestic or international. Our streamlined supply chain provides reliability and peace of mind to our partners across the globe."
};

export const whyChooseUs = [
  {
    title: "Consistent Quality",
    description: "Strict quality control at every stage ensures our fabrics meet global standards"
  },
  {
    title: "Customization",
    description: "We offer customized fabric development to perfectly match your requirements"
  },
  {
    title: "Reliable Timelines",
    description: "Robust supply chain guarantees on-time delivery across India and for exports"
  },
  {
    title: "Trusted Partnership",
    description: "Preferred partner for reputed brands with long-standing B2B relationships"
  },
  {
    title: "Transparent Pricing",
    description: "Competitive and clear pricing for maximum value"
  },
   {
    title: "Corporate Expertise",
    description: "Extensive experience working with corporate clients, export houses and domestic brands"
  }
];

export const productCategories = [
  {
    id: 1,
    name: "Polyester Chiffon",
    description: "Lightweight, sheer fabric perfect for elegant garments and draping applications",
    image: "https://images.unsplash.com/photo-1631089819675-ce4528460a32?crop=entropy&cs=srgb&fm=jpg&q=85",
    applications: "Dresses, sarees, scarves, overlay garments"
  },
  {
    id: 2,
    name: "Crepe",
    description: "Textured fabric with excellent drape, ideal for formal and casual wear",
    image: "https://images.unsplash.com/photo-1761516126149-b570f4e8c899?crop=entropy&cs=srgb&fm=jpg&q=85",
    applications: "Blouses, trousers, dresses, ethnic wear"
  },
  {
    id: 3,
    name: "Satin",
    description: "Smooth, lustrous fabric with luxurious feel and elegant finish",
    image: "https://images.unsplash.com/photo-1739272135664-0c6342ffd470?crop=entropy&cs=srgb&fm=jpg&q=85",
    applications: "Evening wear, linings, formal garments"
  },
  {
    id: 4,
    name: "Twill",
    description: "Durable fabric with diagonal weave pattern, perfect for structured garments",
    image: "https://images.unsplash.com/photo-1756362400384-08face93d841?crop=entropy&cs=srgb&fm=jpg&q=85",
    applications: "Pants, jackets, uniforms, workwear"
  },
  {
    id: 5,
    name: "Polyester Viscose Blends",
    description: "Premium blend combining polyester durability with viscose's luxurious drape and softness",
    image: "https://images.unsplash.com/photo-1706192049174-e5a72dd5c8b6?crop=entropy&cs=srgb&fm=jpg&q=85",
    applications: "Suiting, formal wear, premium garments"
  },
  {
    id: 6,
    name: "Georgette",
    description: "Lightweight, semi-transparent fabric with beautiful texture and flow",
    image: "https://images.unsplash.com/photo-1767839507898-9a8624bdd8b0?crop=entropy&cs=srgb&fm=jpg&q=85",
    applications: "Sarees, dupattas, elegant dresses"
  },
  {
    id: 7,
    name: "Polycotton",
    description: "Versatile blend combining durability of polyester with comfort of cotton",
    image: "https://images.unsplash.com/photo-1576903386142-0ce309b5e450?crop=entropy&cs=srgb&fm=jpg&q=85",
    applications: "Shirts, bedding, home textiles"
  },
  {
    id: 8,
    name: "Poly Mechanical Stretch",
    description: "Advanced fabric with excellent stretch recovery and shape retention for activewear",
    image: "https://images.unsplash.com/photo-1612744220701-2281691eaf24?crop=entropy&cs=srgb&fm=jpg&q=85",
    applications: "Sportswear, activewear, fitted garments"
  },
  {
    id: 9,
    name: "Pocketing & Lining",
    description: "Specialized fabrics for garment interiors and structural support",
    image: "https://images.unsplash.com/photo-1611331282875-3fbcc3add160?crop=entropy&cs=srgb&fm=jpg&q=85",
    applications: "Garment linings, pockets, interiors"
  },
  {
    id: 10,
    name: "Nylon Viscose",
    description: "Luxurious blend offering exceptional strength and elegant drape for premium applications",
    image: "https://images.unsplash.com/photo-1639654687297-bee4f05d8d26?crop=entropy&cs=srgb&fm=jpg&q=85",
    applications: "Premium suiting, formal wear, luxury garments"
  },
  {
    id: 11,
    name: "Rayon Blends",
    description: "Soft, breathable blends combining comfort with excellent drape",
    image: "https://images.unsplash.com/photo-1619043519379-99df2736108d?crop=entropy&cs=srgb&fm=jpg&q=85",
    applications: "Summer wear, kurtis, casual garments"
  },
  {
    id: 12,
    name: "Custom Blends",
    description: "Tailored fabric solutions developed to meet your specific requirements",
    image: "https://images.unsplash.com/photo-1760224254181-adac9e1a1900?crop=entropy&cs=srgb&fm=jpg&q=85",
    applications: "Bespoke garments, special projects"
  }
];

export const corporateClients = [
  { name: "Blackberry", logo: null },
  { name: "Indian Designs", logo: null },
  { name: "Mafatlal", logo: null },
  { name: "Aditya Birla", logo: null },
  { name: "Idoverseas", logo: null },
  { name: "Bokitta", logo: null }
];

export const navigationLinks = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/about" },
  { name: "Products", path: "/products" },
  // { name: "Clients", path: "/clients" },
  { name: "Contact", path: "/contact" }
];
